
import { mapGetters } from "vuex";
import _ from "lodash";
import BarcodeScan from "vue-material-design-icons/BarcodeScan";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";
import { SistemaMixin } from "@/modules/Application";
import { CardBuscaTerminal } from "../../Pdv/components/Cards";
import { Select } from "../../Pdv/components/Form";
import { TECLAS } from "../../Pdv/enums/Documento";
import { quantityOptions } from "@/modules/Application";
import {
  filtrarPorTexto,
  formatarUnidadeMedida,
  normalizarLotes,
  normalizarVariacoes,
} from "./terminalConsultaHelpers";

export default {
  name: "app-terminal-consulta",
  mixins: [SistemaMixin],
  components: {
    BarcodeScan,
    CardBuscaTerminal,
    InformationOutline,
    Select,
    Keypress: () => import("vue-keypress"),
  },
  data() {
    return {
      quantityOptions,
      quantidade: 0,
      produto: null,
      produtos: [],
      teclasEnum: TECLAS,
      urlProdutoImage: null,
      carregandoDetalhes: false,
      erroDetalhes: "",
      filtroVariacao: "",
      filtroLote: "",
      consultaAtual: 0,
    };
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    variacoes() {
      return normalizarVariacoes(this.produto || {});
    },
    lotes() {
      return normalizarLotes(this.produto || {});
    },
    temVariacoes() {
      return this.variacoes.length > 0 || this.possuiVariacao(this.produto);
    },
    temLotes() {
      return this.lotes.length > 0 || this.possuiLote(this.produto);
    },
    variacoesFiltradas() {
      return filtrarPorTexto(this.variacoes, this.filtroVariacao, (item) =>
        item.atributos.flatMap((atributo) => [atributo.nome, atributo.valor])
      );
    },
    lotesFiltrados() {
      return filtrarPorTexto(this.lotes, this.filtroLote, (item) => [
        item.numero,
      ]);
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
  methods: {
    buscarProduto() {
      this.consultaAtual += 1;
      this.produto = null;
      this.produtos = [];
      this.urlProdutoImage = null;
      this.erroDetalhes = "";
      this.filtroVariacao = "";
      this.filtroLote = "";
      this.carregandoDetalhes = false;

      this.$nextTick(() => {
        const input = this.$refs.buscarProduto?.$el?.querySelector("input");
        if (input) input.focus();
      });
    },
    onSearch(search, loading) {
      if (search.length > 1 && search[0] === "+") {
        loading(true);
        this.searchKit(loading, search, this);
        return;
      }

      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        this.search(loading, search, this);
      }
    },
    search: _.debounce(async (loading, search, vm) => {
      if (search === "" || search === null) return loading(false);

      let busca = search;
      if (busca.split("*").length > 1) {
        let quantidade = 1 * 10 * vm.quantityOptions.precision;
        [quantidade, busca] = busca.split("*");
        vm.quantidade = vm.numberToReal(parseFloat(quantidade), "quantidade");
      }

      if (busca === "") return loading(false);

      loading(true);
      try {
        const data = await vm.fetchProdutos(busca, vm.typeFilter);
        vm.produtos = data;

        if (
          data.length === 1 &&
          vm.isBarCode(busca) &&
          Number.parseInt(busca)
        ) {
          await vm.setProduto(data[0]);
        }
      } finally {
        loading(false);
      }

      return true;
    }, 350),
    searchKit: _.debounce(async (loading, search, vm) => {
      try {
        const { data } = await vm.$http.post("/kit/get-kit", { search });
        vm.produtos = data.map((kit) => ({
          ...kit,
          descricao: kit.nome,
          isKit: true,
        }));
      } finally {
        loading(false);
      }
    }, 350),
    async setProduto(produto) {
      if (!produto) return false;

      const idConsulta = ++this.consultaAtual;
      this.produto = produto;
      this.urlProdutoImage = produto.imagem;
      this.erroDetalhes = "";
      this.filtroVariacao = "";
      this.filtroLote = "";
      this.carregandoDetalhes = true;

      try {
        const produtoCompleto =
          (await this.getProdutoCompleto(produto)) || produto;
        const produtoComDetalhes = await this.carregarDadosComplementares(
          produtoCompleto
        );

        if (idConsulta !== this.consultaAtual) return false;

        this.produto = { ...produto, ...produtoComDetalhes };
        this.urlProdutoImage = this.produto.imagem;
      } catch (error) {
        console.error(error);
        if (idConsulta === this.consultaAtual) {
          this.erroDetalhes =
            "Não foi possível carregar todos os detalhes de estoque deste produto.";
        }
      } finally {
        if (idConsulta === this.consultaAtual) this.carregandoDetalhes = false;
      }

      return true;
    },
    async getProdutoCompleto(produto) {
      const id = produto?.id || produto?.id_produto || produto?.codigo;
      if (!id) return null;

      const { data } = await this.$http.post("/produtos/find", { id });
      return data;
    },
    async carregarDadosComplementares(produto) {
      const idProduto = produto?.id || produto?.id_produto;
      const precisaVariacoes =
        idProduto &&
        this.possuiVariacao(produto) &&
        normalizarVariacoes(produto).length === 0;
      const precisaLotes =
        idProduto &&
        this.possuiLote(produto) &&
        normalizarLotes(produto).length === 0;
      const requisicoes = [];

      if (precisaVariacoes) {
        requisicoes.push(
          this.$http
            .post("/produtos/get-combinacao", { id_produto: idProduto })
            .then(({ data }) => ({
              combinacao: data?.combinacao || data || [],
            }))
            .catch((error) => {
              console.error(error);
              return { erroComplemento: true };
            })
        );
      }

      if (precisaLotes) {
        requisicoes.push(
          this.$http
            .post("/produtos/get-lote", {
              id_produto: idProduto,
              compra: true,
            })
            .then(({ data }) => ({ lotes: data || [] }))
            .catch((error) => {
              console.error(error);
              return { erroComplemento: true };
            })
        );
      }

      const detalhes = await Promise.all(requisicoes);
      if (detalhes.some((detalhe) => detalhe.erroComplemento)) {
        this.erroDetalhes =
          "Alguns detalhes de estoque não puderam ser carregados.";
      }

      return Object.assign({}, produto, ...detalhes);
    },
    possuiVariacao(produto) {
      return (
        this.valorBooleano(produto?.variavel) ||
        this.valorBooleano(produto?.possui_variacao)
      );
    },
    possuiLote(produto) {
      return (
        this.valorBooleano(produto?.lote) ||
        this.valorBooleano(produto?.possui_lote)
      );
    },
    valorBooleano(valor) {
      return valor === true || valor === 1 || valor === "1" || valor === "true";
    },
    getPrecoAtacado(produto) {
      return this.getValorNumerico(produto?.preco_atacado);
    },
    formatarUnidadeMedida,
    getValorNumerico(valor) {
      if (valor === null || valor === undefined || valor === "") return 0;
      if (typeof valor === "number") return valor;

      return this.formatNumberToFloat(valor);
    },
    getPrecoAtacadoInfo(produto) {
      const precoAtacado = this.getPrecoAtacado(produto);
      return precoAtacado > 0
        ? ` | Atacado: R$ ${this.numberToReal(precoAtacado, "preco")}`
        : "";
    },
    getKitInfo(kitData) {
      if (kitData.usar_unidade_medida) {
        const unidade = kitData.unidade_medida || {};
        const base = kitData.productOfTradeCollection?.[0]?.product || {};
        const conversor = parseFloat(unidade.conversor) || 0;
        return (
          `1 ${unidade.sigla || ""} de ${base.descricao || ""}` +
          (conversor
            ? ` (${conversor} ${base.unidade_medida?.sigla || "un"})`
            : "") +
          ` - R$ ${this.numberToReal(kitData.valor_unitario, "preco")}`
        );
      }

      return kitData.productOfTradeCollection.reduce(
        (descricao, item, index) =>
          `${descricao}${index + 1} - ${item.product.descricao} - QTD: ${
            item.product.quantidade
          }<br/>`,
        ""
      );
    },
    classeSaldo(quantidade) {
      if (Number(quantidade) < 0) return "saldo--negativo";
      if (Number(quantidade) === 0) return "saldo--zerado";
      return "saldo--positivo";
    },
    formatarDataLote(data) {
      if (!data) return "Não informada";
      const partes = String(data).slice(0, 10).split("-");
      if (partes.length !== 3) return String(data);
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },
    loteVencido(lote) {
      if (!lote.dataValidade) return false;
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return (
        new Date(`${String(lote.dataValidade).slice(0, 10)}T00:00:00`) < hoje
      );
    },
    isBarCode(codigo) {
      return [8, 12, 13, 14].includes(codigo.length);
    },
  },
};
